"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGroupedEventsDate = useGroupedEventsDate;
const react_1 = require("react");
const values_1 = __importDefault(require("lodash/fp/values"));
const dayjs_1 = __importDefault(require("dayjs"));
const getDay = (eventDate) => (0, dayjs_1.default)(eventDate).format('DD-MM');
function useGroupedEventsDate(events, tournamentName) {
    return (0, react_1.useMemo)(() => (0, values_1.default)(events.reduce((acc, event) => {
        const { eventDate } = event;
        if (!acc[getDay(eventDate)]) {
            acc[getDay(eventDate)] = {
                date: eventDate,
                items: [event],
                tournamentName,
            };
        }
        else {
            acc[getDay(eventDate)] = {
                ...acc[getDay(eventDate)],
                items: [...acc[getDay(eventDate)].items, event],
                tournamentName,
            };
        }
        return acc;
    }, {})), [events, tournamentName]);
}
//# sourceMappingURL=useGroupedEventsDate.js.map